import { render, staticRenderFns } from "./PayrollSummaryAnalysis.vue?vue&type=template&id=4879445f"
import script from "./PayrollSummaryAnalysis.vue?vue&type=script&lang=js"
export * from "./PayrollSummaryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports